import cookie from '@/utils/cookie';

export function createHelpUrl({
  id,
  userId,
  uriPath,
}: {
  id: string; // 企点url的id
  userId: number;
  uriPath?: string; // 当前页面的url
  reception_type?: string;
  reception_id?: number;
}) {
  const baseUrl = `https://wpa1.qq.com/${id}?_type=wpa&qidian=true&DisplayinAIO=yes&wpaShowItemId=123&auth=commonAuth`;
  const timestamp = new Date().getTime();
  const source = 5; // 5-服务商系统-已登录
  const token = cookie.get('gdt_protect') || 0;
  const uid = cookie.get('agency_uid') || cookie.get('bm_id') || 0;
  const uri = uriPath || location.href.split('?')[0];

  const code = btoa(`${timestamp}_${source}_${token}_${userId}_${uid}_${btoa(uri)}`);

  return `${baseUrl}&code=${code}`;
}
